//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import plvThresholds from "@/components/Diagrams/sidebar/plv-thresholds.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AppMatrixModal from "@/pages/main/views/Reports/appMatrixModalSts.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";

export default {
    name: "AppStats",
    components: {
        AppMatrixModal,
        "plv-thresholds": plvThresholds,
        AQDropdown,
        AQButton
    },
    props: {
        allTasksReady: {
            type: Boolean,
            default: false
        },
        selectedPluginData: {
            type: Object,
            default: () => ({})
        },
        allTasks: {
            type: Boolean,
            default: false
        },
        collapsibleObj: {
            type: Object,
            default: () => ({})
        },
        collapsibleOpenId: {
            type: String,
            default: ""
        },
        turnAroundValue: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            dataSelectValue: "",
            detailsTaskStatistics: {},
            showThresholdSetup: false,
            showApprovalMatrixLvls: false,
            isApprovalMatrix: false,
            timeInfoPerActivity: {},
            timeInfoPerProcess: {},
            currActivityValue: null,
            defaultSelect: "ONE_WEEK",
            select: "",
            openTasksCount: 0
        };
    },
    computed: {
        ...mapGetters("reports", [
            "turaroundTypes",
            "getFilteredData",
            "getStatsInfoPerProcess",
            "getAllTasks",
            "getSelectedProcessStatistics"
        ]),
        ...mapGetters("apps", ["currentApp"]),
        turaroundOpts() {
            return [...this.turaroundTypes];
        },
        showDeadlineIfNotProcess() {
            let elToSend = "";
            if (this.allTasks) {
                elToSend = null;
            } else if (this.selectedPluginData.id !== "PROCESS_PLUGIN") {
                elToSend = this.$t("liveView.statistics.taskDeadline");
            }
            return elToSend;
        },
        showDeadlineTat() {
            let elToSend = "";
            if (this.allTasks) {
                elToSend = null;
            } else if (this.selectedPluginData.id !== "PROCESS_PLUGIN") {
                elToSend = this.convertToHHMM(this.timeInfoPerActivity.deadline);
            }
            return elToSend;
        },
        currentTimeFrameTat() {
            return this.convertToHHMM(this.allTasks ? this.detailsTaskStatistics.currTimeFrame : this.timeInfoPerActivity.currentTimeFrameTat);
        },
        previousTimeFrameTat() {
            return this.convertToHHMM(this.allTasks ? this.detailsTaskStatistics.prevTimeFrame : this.timeInfoPerActivity.previousTimeFrameTat);
        },
        timeFrameVariation() {
            return this.convertToHHMM(this.allTasks ? this.detailsTaskStatistics.timeFrameVariation : this.timeInfoPerActivity.timeFrameVariation, true);
        }
    },
    watch: {
        allTasksReady: {
            handler(value) {
                if (value && this.select) {
                    this.detailsTaskStatistics = this.setAllInstances();
                }
            },
            immediate: true
        },
        collapsibleOpenId: {
            handler(v) {
                if (v && v === this.collapsibleObj.uuid) {
                    const selectedTask = this.getAllTasks.filter(elem => elem.activityId === v);
                    this.openTasksCount = selectedTask.length ? selectedTask[0].total : 0;
                    for (let i = 0; i < this.getFilteredData.length; i++) {
                        if (this.getFilteredData[i].activityId === v) {
                            const {
                                overdue, attention, onTrack, atRisk, total
                            } = this.getFilteredData[i];
                            Object.assign(this.detailsTaskStatistics, {
                                overdue, attention, onTrack, atRisk, total
                            });
                        }
                    }
                    const payload = {
                        timeFrame: this.turnAroundValue || this.select,
                        activityId: v,
                        processDefinitionId: this.getSelectedProcessStatistics.id,
                        applicationId: this.currentApp.id
                    };
                    if (
                        this.collapsibleObj
                        && this.collapsibleObj.id === "APPROVAL_PLUGIN"
                    ) {
                        this.isApprovalMatrix = true;

                        this.getStatsPerLvlsAppMatrix(payload).then(data => {
                            this.timeInfoPerActivity = data.data;
                        });
                    } else {
                        this.getStatsPerActivity(payload).then(rsp => {
                            this.timeInfoPerActivity = rsp.data;
                        });
                    }
                }
            },
            immediate: true
        },
        turnAroundValue: {
            handler(v) {
                if (
                    v
                    && this.collapsibleOpenId
                    && this.collapsibleOpenId === this.collapsibleObj.uuid
                ) {
                    for (let i = 0; i < this.getFilteredData.length; i++) {
                        if (
                            this.getFilteredData[i].activityId
                            === this.collapsibleOpenId
                        ) {
                            const {
                                overdue, attention, onTrack, atRisk, total
                            } = this.getFilteredData[i];
                            Object.assign(this.detailsTaskStatistics, {
                                overdue, attention, onTrack, atRisk, total
                            });
                        }
                    }
                    const payload = {
                        timeFrame: this.turnAroundValue || this.select,
                        activityId: this.collapsibleOpenId,
                        processDefinitionId: this.getSelectedProcessStatistics.id,
                        applicationId: this.currentApp.id
                    };
                    if (
                        this.collapsibleObj
                        && this.collapsibleObj.id === "APPROVAL_PLUGIN"
                    ) {
                        this.isApprovalMatrix = true;

                        this.getStatsPerLvlsAppMatrix(payload).then(data => {
                            this.timeInfoPerActivity = data.data;
                        });
                    } else {
                        this.getStatsPerActivity(payload).then(rsp => {
                            this.timeInfoPerActivity = rsp.data;
                        });
                    }
                }
            },
            immediate: true
        },
        select: {
            handler(v) {
                if (v) {
                    this.detailsTaskStatistics = this.setAllInstances();
                }
            }
        },
        getSelectedProcessStatistics: {
            handler(v) {
                if (v && v.id) {
                    this.detailsTaskStatistics = this.setAllInstances();
                }
            }
        }
    },
    methods: {
        ...mapActions("reports", [
            "getStatsPerProcess",
            "getStatsPerActivity",
            "getStatsPerLvlsAppMatrix",
            "getAppMatrixUncompletedTasksInfo"
        ]),
        setAllInstances() {
            const dataToSend = {
                onTrack: 0,
                attention: 0,
                atRisk: 0,
                overdue: 0,
                total: 0,
                nrCompleted: 0,
                currTimeFrame: 0,
                prevTimeFrame: 0,
                timeFrameVariation: 0,
                currentOpenInstances: 0
            };
            this.getAllTasks.forEach(element => {
                dataToSend.onTrack += element.onTrack;
                dataToSend.attention += element.attention;
                dataToSend.atRisk += element.atRisk;
                dataToSend.overdue += element.overdue;
                dataToSend.total
                    += element.onTrack
                    + element.attention
                    + element.atRisk
                    + element.overdue;
            });
            const payload = {
                timeFrame: this.select || this.turnAroundValue,
                processDefinitionId: this.getSelectedProcessStatistics.id,
                applicationId: this.currentApp.id
            };
            this.getStatsPerProcess(payload).then(rsp => {
                dataToSend.nrCompleted = rsp.data.totalCompleted;
                dataToSend.currTimeFrame = rsp.data.currentTimeFrameTat;
                dataToSend.prevTimeFrame = rsp.data.previousTimeFrameTat;
                dataToSend.timeFrameVariation = rsp.data.timeFrameVariation;
                dataToSend.currentOpenInstances = rsp.data.currentOpenInstances;
            });
            return dataToSend;
        },
        changeValue(v) {
            this.select = v && v[0] ? v[0].value : "";
            if (this.select) {
                this.$emit("changeData", this.select);
            }
        },
        setThresholds() {},
        timeVarStyle(value) {
            let classToReturn = "";
            if (value) {
                const str = value.toString();
                if (str.charAt(0) === "-") {
                    classToReturn = "secondary-class";
                } else if (str === "00:00:00") {
                    classToReturn = "normal-class";
                } else {
                    classToReturn = "error-class";
                }
            }
            return classToReturn;
        },
        openAppMatrixModal() {
            const payload = {
                activityId: this.collapsibleObj.uuid,
                timeFrame: this.turnAroundValue || this.select,
                processDefinitionId: this.getSelectedProcessStatistics.id,
                applicationId: this.currentApp.id
            };
            this.getAppMatrixUncompletedTasksInfo(
                this.collapsibleObj.uuid
            ).then(() => {
                this.getStatsPerLvlsAppMatrix(payload).then(() => {
                    this.showApprovalMatrixLvls = true;
                });
            });
        },
        convertToHHMM(val, tFrame) {
            if (typeof val === "number") {
                let secs = val * 60;
                let sign = "";
                if (tFrame) {
                    if (val < 0) {
                        sign = "-";
                    } else if (val > 0) {
                        sign = "+";
                    }
                }
                secs = Math.abs(secs);
                const hours = Math.floor(secs / (60 * 60));
                const divisorForMinutes = secs % (60 * 60);
                const minutes = Math.floor(divisorForMinutes / 60);
                const divisorForSeconds = divisorForMinutes % 60;
                const seconds = Math.ceil(divisorForSeconds);
                return (
                    `${sign
                    + String(hours).padStart(2, "0")
                    }:${
                        String(minutes).padStart(2, "0")
                    }:${
                        String(seconds).padStart(2, "0")}`
                );
            }
            return "00:00:00";
        }
    }
};
